import { setCanvasStore } from "~/solidJs/entities/MagicBrushCanvas";
import { setIsHistoryVisible, setNodeInstruction } from "~/solidJs/shared/models/globalStores";
import {
	getIsShowChatGpt,
	setIsChatGptVisible
} from "~/solidJs/widgets/ChatGpt/models/isShowChatGpt";
import { composeStore } from "~/solidJs/widgets/Compose/model/composeModel";
import type { NodeInstruction } from "~/solidJs/widgets/NodeInstructionWidget/NodeInstructionWidget";

export enum SidebarModes {
	History = "history",
	ChatGpt = "ChatGpt",
	Inpaint = "Inpaint",
	NodeInstruction = "NodeInstruction",
	Assistant = "Assistant",
	Compose = "Compose",
	Closed = "Closed"
}

const setFunctions: {
	mode: SidebarModes;
	setter: (val: boolean) => void;
}[] = [
	{
		mode: SidebarModes.History,
		setter: setIsHistoryVisible
	},
	{
		mode: SidebarModes.ChatGpt,
		setter: (val) =>
			setIsChatGptVisible({
				dialogue: val,
				assistaint: getIsShowChatGpt().assistaint
			})
	},
	{
		mode: SidebarModes.Assistant,
		setter: (val) =>
			setIsChatGptVisible({
				dialogue: getIsShowChatGpt().dialogue,
				assistaint: val
			})
	},
	{
		mode: SidebarModes.Inpaint,
		setter: (val) => setCanvasStore("visible", val)
	},
	{
		mode: SidebarModes.Compose,
		setter: (val) => composeStore.setComposeStore((prev) => ({ ...prev, isVisible: val }))
	},
	{
		mode: SidebarModes.NodeInstruction,
		setter: (val) => {
			if (val) return val;
			setNodeInstruction({ isVisible: false });
		}
	}
];

export const toggleSidebarWidget = (mode: SidebarModes) => {
	for (const el of setFunctions) {
		el.setter(mode === el.mode);
	}
};
export const showNodeInstruction = (instruction: NodeInstruction) => {
	toggleSidebarWidget(SidebarModes.NodeInstruction);
	setNodeInstruction(instruction);
};
